import React from 'react'
import PropTypes from 'prop-types'
import withPageEndlessScrolling from 'shared/hocs/withPageEndlessScrolling'
import { MostViewedTag } from 'LiveBoard/components/shared/MostViewedTag'
import { ItemTile } from '../ItemTile'

import './style.css.scss'

const DISTANCE_FROM_BOTTOM = 450

class ItemsGrid extends React.Component {
  componentDidMount() {
    const { provideContainer } = this.props
    provideContainer && provideContainer(this.grid)
  }

  componentWillUnmount() {
    const { provideContainer } = this.props
    provideContainer && provideContainer(null)
  }

  render() {
    const {
      items, itemIds, mostViewedItemId, themeColorHex, gatingEnabled,
      showViews, showLikes, showItemType, showItemDescription,
      onItemClick, getItemUrl
    } = this.props

    return (
      <div className='items-container' ref={ref => this.grid = ref}>
        {
          itemIds.map((itemId, index) => {
            const item = items[itemId]
            const isGated = gatingEnabled && item.is_gated
            return (
              <section
                className={`item-tile-container ${isGated ? 'gated' : ''}`}
                key={item.id}>
                {showViews && item.id == mostViewedItemId && <MostViewedTag />}
                <ItemTile
                  item={item}
                  themeColorHex={themeColorHex}
                  showViews={showViews}
                  showLikes={showLikes}
                  showItemType={showItemType}
                  showItemDescription={showItemDescription}
                  onClick={onItemClick}
                  getItemUrl={getItemUrl} />
              </section>
            )
          })
        }
      </div>
    )
  }
}

ItemsGrid.propTypes = {
  items: PropTypes.object,
  itemIds: PropTypes.array,
  mostViewedItemId: PropTypes.number,
  themeColorHex: PropTypes.string.isRequired,
  provideContainer: PropTypes.func.isRequired,
  onItemClick: PropTypes.func.isRequired,
  gatingEnabled: PropTypes.bool,
  showViews: PropTypes.bool,
  showLikes: PropTypes.bool,
  showItemType: PropTypes.bool,
  showItemDescription: PropTypes.bool,
  getItemUrl: PropTypes.func
}

export default withPageEndlessScrolling(ItemsGrid, DISTANCE_FROM_BOTTOM)
